import { Row, Select, SelectProps } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import { Field, FieldProps } from 'formik';
import { CSSProperties, FC } from 'react';
import { Address } from 'redux/services/chuckieSue/models/addresses';
import { FormLabel } from './FormLabel';

interface Props extends SelectProps {
  fieldName: string;
  label: string;
  labelStyle?: CSSProperties;
  optionsArr?: string[];
  addressOptionsArr?: Address[];
  helpIcon?: boolean;
}

export const FieldInputSelect: FC<Props> = ({ fieldName, label, labelStyle, optionsArr, addressOptionsArr, ...rest }) => {
  const addressOptions = addressOptionsArr?.map((address) => ({
    label: `${address.code} -- ${address?.street1} ${address?.city}, ${address?.subdivision?.localCode} ${address?.postalCode}`,
    value: address.id
  }));

  const handleFilterOption = (input: string, option: DefaultOptionType | undefined): boolean => {
    if (!!option && typeof option.label === 'string')
      return (
        !!option &&
        !!option.value &&
        typeof option.value === 'string' &&
        typeof option.label === 'string' &&
        (option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0)
      );

    return !!option && !!option.value && typeof option.value === 'string' && option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };

  return (
    <Field name={fieldName}>
      {({
        field, // { name, value, onChange, onBlur }
        form: { setFieldTouched, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
        meta
      }: FieldProps): JSX.Element => {
        const handleChange = (val: string): void => {
          setFieldValue(fieldName, val);
        };

        return (
          <Row style={{ width: '100%' }}>
            <FormLabel style={labelStyle} label={label} />

            <Select
              {...field}
              showSearch
              allowClear
              onClick={(e): void => e.stopPropagation()}
              onClear={(): void => {
                setFieldTouched(fieldName, true);
              }}
              filterOption={handleFilterOption}
              onChange={handleChange}
              status={meta.error && meta.touched ? 'error' : undefined}
              onFocus={(): void => {
                setFieldTouched(fieldName, false);
              }}
              onBlur={(): void => {
                setFieldTouched(fieldName, true);
              }}
              style={{ width: '100%' }}
              {...rest}
            />
            <div className={meta.touched && meta.error ? 'field-error-show' : 'field-error-hide'}>{meta.error}</div>
          </Row>
        );
      }}
    </Field>
  );
};
